<div [formGroup]="form" class="mb-2">
    <div class="d-flex justify-content-between">
        <div class="btn-toolbar">
            Fra: <app-month-picker placeholder="mm-åå" formControlName="startDate"></app-month-picker>
            Til: <app-month-picker placeholder="mm-åå" formControlName="untilDate" [lastDayOfMonth]="true"></app-month-picker>
            <div ngbDropdown class="d-inline-block">
                <button class="btn btn-primary btn-sm btn--menu ms-2" id="kaSelect" ngbDropdownToggle>KA: {{ _filterOptions?.ka ? _filterOptions.ka.fornavn + ' ' + _filterOptions.ka.efternavn : 'Alle' }}</button>
                <div ngbDropdownMenu aria-labelledby="kaSelect">
                    <button class="dropdown-item" (click)="onSelectKA(undefined)">Alle</button>
                    <button *ngFor="let user of kaList$ | async" class="dropdown-item" (click)="onSelectKA(user)">{{ user?.fornavn + ' ' + user?.efternavn }}</button>
                </div>
            </div>
            <div ngbDropdown class="d-inline-block">
                <button class="btn btn-primary btn-sm btn--menu ms-2" id="laSelect" ngbDropdownToggle>LA: {{ _filterOptions?.la ? _filterOptions.la.fornavn + ' ' + _filterOptions.la.efternavn : 'Alle' }}</button>
                <div ngbDropdownMenu aria-labelledby="laSelect">
                    <button class="dropdown-item" (click)="onSelectLA(undefined)">Alle</button>
                    <button *ngFor="let user of laList$ | async" class="dropdown-item" (click)="onSelectLA(user)">{{ user?.fornavn + ' ' + user?.efternavn }}</button>
                </div>
            </div>
            <div ngbDropdown class="d-inline-block">
                <button class="btn btn-primary btn-sm btn--menu ms-2" id="godkendte" ngbDropdownToggle>{{getGodkendtLabel}}</button>
                <div ngbDropdownMenu aria-labelledby="godkendte">
                    <button class="dropdown-item" (click)="onGodkendte(null)">Alle</button>
                    <button class="dropdown-item" (click)="onGodkendte(true)">Godkendte</button>
                    <button class="dropdown-item" (click)="onGodkendte(false)">Ikke godkendte</button>
                </div>
            </div>
            <button
                class="btn btn--menu btn-primary btn-sm btn__toggle ms-2"
                [class.active]="_filterOptions?.acontoOnly"
                type="button"
                (click)="acontoToggle()"
            >Aconto</button>
            <app-search-input
                class="d-flex"
                [search]="searchFor || ''"
                (searchChange)="onSearch($event)"
            ></app-search-input>
        </div>
        <div class="btn-toolbar">
            <button type="button" class="btn btn-sm btn-primary" (click)="onGodkendMarked()">Godkend valgte</button>
        </div>
    </div>
</div>
